import styled from "styled-components";

export const DPadContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    div{
        display: flex;
        gap: 50px;
    }
`;